import { render, staticRenderFns } from "./TeacherInfoFeeArea.vue?vue&type=template&id=6a44bdaf&scoped=true&"
import script from "./TeacherInfoFeeArea.vue?vue&type=script&lang=js&"
export * from "./TeacherInfoFeeArea.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfoFeeArea.vue?vue&type=style&index=0&id=6a44bdaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44bdaf",
  null
  
)

export default component.exports